import {ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild} from "@angular/core";
import {StockService} from "../../services/stock.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Stock} from "../../../shared/view-model/stock";
import {Observable} from "rxjs/Observable";
import {ApolloQueryObservable} from "apollo-angular";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {AbstractListView} from "../../../core/visbos-core/ui/components/abstract-list-view";
import {Depot} from "../../../shared/view-model/store-management/depot.type";
import {AddStockToCartComponent} from "../../procurement/add-stock-to-cart/add-stock-to-cart.component";
import {GenericModalComponent} from "../../../core/visbos-core/ui/forms/generic-modal/generic-modal.component";
import {ProcurementService} from "../../services/procurement-service/procurement.service";
import {SessionActions} from "../../../shared/actions/session.actions";
import {BarcodeService} from "../../../identity/services/barcode.service";
import {MessageType} from "../../../shared/redux-store/session/session.types";
import {PrintedSheetCategory} from "../../../medicine-stickers/model/printed-sheets.enum";
import {DepotYard} from "../../../shared/view-model/store-management/depot-yard.type";
import {FileService} from "../../../core/visbos-core/http/file.service";
import {MoveStockComponent} from "../components/move-stock/move-stock.component";
import {StockItemService} from "../../services/stock-item-service/stock-item.service";
import {debounceTime, distinctUntilChanged, map} from "rxjs/operators";
import {StocktakingService} from '../../services/stocktaking/stocktaking.service';
import * as _ from 'lodash';
import {DatatableComponent} from '../../../core/visbos-core/ui/components/datatable/datatable.component';
import {StockListStateService} from './stock-list-state.service';

@Component({
  selector: 'vb-stock-list',
  templateUrl: './stock-list.component.html',
  styleUrls: ['./stock-list.component.css']
})
export class StockListComponent extends AbstractListView implements OnInit, OnDestroy {

  @ViewChild('batchCellTmpl')
  batchCellTmpl: TemplateRef<any>;

  // Stock editing templates
  @ViewChild('minStockTmpl')
  minStockTmpl: TemplateRef<any>;

  @ViewChild('shallStockTmpl')
  shallStockTmpl: TemplateRef<any>;

  @ViewChild('reportStockTmpl')
  reportStockTmpl: TemplateRef<any>;

  @ViewChild('actStockTmpl')
  actStockTmpl: TemplateRef<any>;

  @ViewChild('depotYardTmpl')
  depotYardTmpl: TemplateRef<any>;

  @ViewChild('stockDetails')
  stockDetails: TemplateRef<any>;

  @ViewChild('stockCartFormComp')
  stockCartFormComp: AddStockToCartComponent;

  @ViewChild('stockCartModal')
  stockCartModal: GenericModalComponent;

  @ViewChild('moveStocksModal')
  moveStocksModal: GenericModalComponent;

  currentStock: Stock;
  currentStockForm: FormGroup;

  @ViewChild('barcodeStickersModal')
  barcodeStickersModal: GenericModalComponent;

  @ViewChild('stocksTable')
  table: DatatableComponent;

  messages = {
    emptyMessage: 'Keine Bestandsposten vorhanden',
    totalMessage: 'Bestandsposten insgesamt'
  };

  private stocks$: ApolloQueryObservable<Stock[]>;
  stocks: Stock[] = [];

  depotForm: FormControl;

  selectedDepotCuid$: Observable<string>;

  private selectedStocks: string[] = [];

  PrintedSheetCategory;

  constructor(private stockService: StockService,
              private stockItemService: StockItemService,
              private procurementService: ProcurementService,
              private bcService: BarcodeService,
              private router: Router,
              private route: ActivatedRoute,
              private fb: FormBuilder,
              private fileService: FileService,
              private stocktakingService: StocktakingService,
              private state: StockListStateService,
              sessionActions: SessionActions, cd: ChangeDetectorRef) {

    super(sessionActions, cd);

    this.stockItemService = stockItemService;

    this.PrintedSheetCategory = PrintedSheetCategory;

    this.selectedDepotCuid$ = this.route.params.pipe(map(({depotCuid}) => depotCuid));

    this.actions = [
      {
        label: 'Neue Bestände anlegen',
        icon: 'fa-plus',
        helpText: 'Neue Bestände im Lager anlegen',
        action: () => this.showNewStockForm.apply(this)
      },
      {
        label: 'Bestandsliste exportieren',
        icon: 'fa-file-export',
        helpText: 'Liste aller Bestände des Standorts als Excel-Datei exportieren',
        action: () => this.exportStockList.apply(this)
      },
      {
        label: 'Barcodes drucken',
        icon: 'fa-barcode',
        helpText: 'Barcodes für die ausgewählten Bestände auf Etiketten drucken',
        action: () => this.onCreateBarcodesPageClicked.apply(this),
        disabled: () => !(this.selectedStocks && this.selectedStocks.length > 0)
      },
      { //TODO: RFID-Permission?
        label: 'Lager per RFID inventarisieren',
        icon: 'fa-broadcast-tower',
        helpText: 'Das über den Filter ausgewählte Lager per RFID-Scan inventarisieren',
        disabledText: 'Bitte wählen Sie zuerst im Filter ein Lager aus',
        action: () => this.startStocktakingClicked.apply(this),
        disabled: () => !(this.route.snapshot.params.depotCuid)
      }

    ]

  }

  ngOnInit() {

    this.isLoading = true;

    this.searchTerm = this.fb.control(null);

    this.dataSubscriptions.push(
      this.searchTerm.valueChanges.pipe(
        distinctUntilChanged(),
        debounceTime(500)
      ).subscribe((term: any) => {
        this.state.searchTerm = term;
        this.filterItems(term, true); // if the user types a search term, reset the page to the first page as it is unknown, if the page setting still fits the filtered item list
      })
    );

    // If a search term is set in the state, patch the form control and filter the items without changing the page
    if (this.state.searchTerm) {
      this.searchTerm.patchValue(this.state.searchTerm, {emitEvent: false});
      this.filterItems(this.state.searchTerm, false);
    }

    this.stocks$ = this.stockService.getStocksForDepot(this.selectedDepotCuid$);
    this.addComponentData(this.stocks$);
    this.dataSubscriptions.push(this.stocks$.subscribe((stocks: any) => {
      this.stocks = stocks;
      this.filterItems(this.searchTerm.value, false);
      this.isLoading = false;
    }, err => {
      console.warn("Fehler", [err]);
    }));

    this.columns = [
      {prop: 'label', name: 'Bezeichner', minWidth: 250, flexGrow: 3},
      {prop: 'min_stock', name: 'Min', cellTemplate: this.minStockTmpl, minWidth: 60, maxWidth: 100, flexGrow: 1},
      {
        prop: 'report_stock',
        name: 'Melde',
        cellTemplate: this.reportStockTmpl,
        minWidth: 60,
        maxWidth: 100,
        flexGrow: 1
      },
      {
        prop: 'shall_stock',
        name: 'Soll',
        cellTemplate: this.shallStockTmpl,
        minWidth: 60,
        maxWidth: 100,
        flexGrow: 1
      },
      {
        prop: 'act_stock',
        name: 'Aktuell',
        cellTemplate: this.actStockTmpl,
        minWidth: 60,
        maxWidth: 100,
        flexGrow: 1
      },
      {
        prop: 'depot_yard',
        name: 'Lagerplatz',
        cellTemplate: this.depotYardTmpl,
        comparator: this.sortByDepotYard.bind(this),
        minWidth: 150,
        flexGrow: 2
      },
      {
        name: 'Chargen',
        prop: 'product_batches',
        cellTemplate: this.batchCellTmpl,
        minWidth: 200,
        flexGrow: 2,
        sortable: false
      },
    ];

  }

  showNewStockForm() {
    this.router.navigate(['neu'], {relativeTo: this.route});
  }

  setDepot(depot: Depot) {
    if (depot) {
      this.router.navigate(['client/lagerverwaltung/lager', depot.cuid, 'bestand']);
    }
  }

  unsetDepot() {
    this.router.navigate(['client/lagerverwaltung/bestand']);
  }

  sortByDepotYard(row1: DepotYard, row2: DepotYard) {
    if (!row1.label) {
      return -1;
    }
    if (!row2.label) {
      return 1;
    }
    return row1.label.localeCompare(row2.label);
  }

  onCellUpdate(row, res, index) {
    this.stockService.updateStock(res, row.cuid, false).toPromise()
      .then()
      .catch(err => this.sessionActions.throwError(err, "Fehler beim Speichern!"));
  }

  updateDepotYard(row, depotYard: DepotYard, rowIndex) {
    let data = {
      depot_yard_id: depotYard ? depotYard.cuid : null
    };
    this.stockService.updateStock(data, row.cuid, false).toPromise()
      .then()
      .catch(err => this.sessionActions.throwError(err, "Fehler beim Speichern!"));
    this.editing[rowIndex + '-depot_yard'] = false;
  }


  showStockDetail(stockCuid: string) {
    this.router.navigate([stockCuid], {relativeTo: this.route});
  }

  editStock(stock: Stock) {
    this.router.navigate([stock.cuid, 'edit'], {relativeTo: this.route});
  }

  deleteStock(stock: Stock) {
    this.stockService.deleteStock(stock.cuid).toPromise()
      .then()
      .catch(err => this.sessionActions.throwError(err, "Fehler beim Löschen des Bestands!"));
  }

  putStockIntoShoppingCart(stock: Stock) {
    this.currentStock = stock;
    this.cd.detectChanges();
    this.stockCartModal.show();
  }

  onStockToCartSave() {
    let input = this.stockCartFormComp.stockCartForm.value;

    this.procurementService.createShoppingCartItem(null, input.stock_cuid, input.product_packing_cuid, null).toPromise()
      .then(res => {
        this.currentStock = null;
      })
      .catch(err => {
        console.error("Error for saving", [err]);
        this.currentStock = null;
      });
  }

  onStockCartCancel() {
    this.currentStock = null;
  }


  isUbdOver(ubd: Date) {
    if (new Date(ubd) < new Date()) {
      return true;
    }
    return false;
  }

  filterItems(searchTerm, resetPage = false) {

    if (resetPage) {
      this.table.resetToFirstPage();
    }

    if (!searchTerm || searchTerm == "") {
      this.rows = this.stocks;
    } else {
      if (this.stocks) {
        let st = searchTerm.trim().toLowerCase();
        this.rows = this.stocks.filter((si: Stock) => {

          let inCols = this.findStringInTable(si, this.columns, st);
          if (inCols) {
            return true;
          }

          let inKeyWords = si.keywords && si.keywords.find(k => _.get(k, 'label', '') ? _.get(k, 'label', '').toLowerCase().includes(st) : false);
          if (inKeyWords) {
            return true;
          }

          let inStockItemKeyWords = si.stock_item && si.stock_item.keywords && si.stock_item.keywords.find(k => _.get(k, 'label', '') ? _.get(k, 'label', '').toLowerCase().includes(st) : false);
          if (inStockItemKeyWords) {
            return true;
          }

          return (_.get(si, 'stock_item.label', '') ? _.get(si, 'stock_item.label', '').toLowerCase().includes(st) : false) ||
            (_.get(si, 'stock_item.visbos_article_number', '') ? _.get(si, 'stock_item.visbos_article_number', '').toLowerCase().includes(st) : false) ||
            (_.get(si, 'stock_item.category.label', '') ? _.get(si, 'stock_item.category.label', '').toLowerCase().includes(st) : false) ||
            (_.get(si, 'stock_item.default_product.supplier.label', '') ? _.get(si, 'stock_item.default_product.supplier.label', '').toLowerCase().includes(st) : false);

        });
      }
    }
  }

  /**
   * Defines the CSS styles for highlighting the stock
   * @param stock the stock to format
   * @returns {{bg-warning: boolean, bg-danger: boolean, bg-success: boolean}} a ngClass array with the styles
   */
  setClasses(stock: Stock) {
    if (!stock) {
      return {};
    }

    let cssClasses = {
      'text-warning': stock.act_stock >= stock.min_stock && stock.act_stock < stock.report_stock,
      'text-danger': stock.act_stock < stock.min_stock,
      'text-success': stock.act_stock >= stock.report_stock,
    };
    return cssClasses;
  }

  onItemSelected(selected: Stock[]) {
    this.selectedStocks = selected.sort((stock1, stock2) => {
      const label1 = stock1.depot_yard ? stock1.depot_yard.label : "";
      const label2 = stock2.depot_yard ? stock2.depot_yard.label : "";
      return label1.localeCompare(label2)
    }).map((s) => s.cuid);
  }

  onCreateBarcodesPageClicked() {
    this.barcodeStickersModal.show();
  }

  onGenerateBarcodesClicked(formData) {

    let cuids = this.selectedStocks;
    let printedSheetId = formData.sheetCuid;
    let startRow = formData.startRow;
    let startColumn = formData.startColumn;

    this.generateBarcodesPdf(null, cuids, printedSheetId, startRow, startColumn);

  }

  private generateBarcodesPdf(barcodeCuids: string[] = null, identifiableCuids: string[] = null, printedSheetCuid: string, startRow: number, startColumn: number) {

    let res = this.bcService.generateBarcodeStickersPdf(barcodeCuids, identifiableCuids, printedSheetCuid, startRow, startColumn);

    this.sessionActions.pushMessage("Barcode-Etikettenbogen wird generiert, dies kann einen Moment dauern...", MessageType.INFO, "Druckbogen erzeugen");

    res.subscribe(res => {
        let pdfString = res.data.generateBarcodeStickersPDF;
        let blob = this.fileService.base64toBlob(pdfString, 'application/pdf', 512);
        this.fileService.saveAs(blob, 'barcodes.pdf');
      },
      err => {
        this.sessionActions.throwError(err, "Fehler bei der Generierung der Barcodes!")
      })

  }

  public onMoveStocksClicked(stock: Stock) {
    this.currentStockForm = MoveStockComponent.initControl(this.fb);
    this.currentStock = stock;
    this.moveStocksModal.show();
  }

  public moveStocks() {
    const _data = [this.currentStockForm.get('data').value];
    const _auth_data = this.currentStockForm.get('auth_data').value;
    const _generate_vouchers = this.currentStockForm.get('generate_vouchers').value;

    this.stockService.moveStocks(_data, _auth_data, _generate_vouchers).toPromise()
      .then(res => {

        this.sessionActions.pushMessage("Bestand erfolgreich verschoben", MessageType.SUCCESS);

        const pdfWithdrawal = res.data.moveStocks.voucher_withdrawal;
        const pdfWarehousing = res.data.moveStocks.voucher_warehousing;

        if (pdfWithdrawal) {
          let data = this.fileService.base64toBlob(pdfWithdrawal, 'application/pdf', 512);
          this.fileService.saveAs(data, 'warenausgangsbeleg.pdf');
        }

        if (pdfWarehousing) {
          let data = this.fileService.base64toBlob(pdfWarehousing, 'application/pdf', 512);
          this.fileService.saveAs(data, 'wareneingangsbeleg.pdf');
        }

        this.currentStockForm.reset();
        this.currentStock = null;
      })
      .catch(err => this.sessionActions.throwError(err));
  }

  startStocktakingClicked() {
    let depotCuid = this.route.snapshot.params.depotCuid;
    if (!depotCuid) {
      this.sessionActions.pushMessage("Kein Lager ausgewählt, RFID-Inventur wird nicht durchgeführt!", MessageType.WARNING, "RFID-Inventur");
      return;
    }

    this.dataSubscriptions.push(this.stocktakingService.autoStocktakingForDepot({
      depotCuid: depotCuid
    }).subscribe(res => {
      this.sessionActions.pushMessage("Die automatische Lagerinventur wurde erfolgreich durchgeführt, der Lager-Bestand wird aktualisiert...!", MessageType.SUCCESS, "RFID-Inventur");
    }, err => {
      this.sessionActions.throwError(err, "Fehler bei der automatischen Lagerinventur");
    }));
  }

  private exportStockList() {

    this.sessionActions.pushMessage("Bestandsliste wird generiert, dies kann einen Moment dauern...", MessageType.INFO, "Bestandsliste erzeugen");

    this.stockService.generateStocklistExport(this.activeAdminUnitCuid).subscribe(response => {
      this.fileService.saveResponseToFileSystem(response);
    }, err => {
      this.sessionActions.throwError(err, "Fehler beim Erzeugen der Datei!");
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/stock/stock-list/stock-list.component.ts